import type { FieldDef } from '../../types'
import { BuildStatus, InventorySystemTypes } from '../../types'
import { CreateEntityPage } from '../CreateEntityPage/CreateEntityPage'
import { createInventorySystemProfile } from '../../services/api/createInventorySystemProfile'
import { useTenantGroups } from '../../hooks/useTenantGroups'

const inventorySystemTypeOptions = Object.values(InventorySystemTypes).map(
  (v) => ({
    value: v,
    label: v,
  })
)

const buildStatusOptions = [
  { value: BuildStatus.Idle, label: BuildStatus.Idle },
  { value: BuildStatus.Stopped, label: BuildStatus.Stopped },
]

export function CreateInventorySystemProfilePage() {
  const { tenantGroups, isLoading } = useTenantGroups()

  const tenantGroupOptions = tenantGroups
    .map((tg) => ({ value: tg.id, label: `${tg.code} (ID: ${tg.id})` }))
    .sort((a, b) => a.label.localeCompare(b.label))

  const fields: FieldDef[] = [
    { name: 'code', label: 'Code', type: 'text' },
    { name: 'name', label: 'Name', type: 'text' },
    {
      name: 'inventorySystemType',
      label: 'Inventory System Type',
      type: 'select',
      options: inventorySystemTypeOptions,
      defaultValue: InventorySystemTypes.Lineup,
    },
    {
      name: 'buildSchedule',
      label: 'Build Schedule',
      type: 'cron',
      defaultValue: '0 0 * * *',
    },
    {
      name: 'buildStatus',
      label: 'Build Status',
      type: 'select',
      options: buildStatusOptions,
      defaultValue: BuildStatus.Idle,
    },
    {
      name: 'availabilityBuildEnabled',
      label: 'Enable Availability Build',
      type: 'checkbox',
      defaultValue: true,
    },
    {
      name: 'tenantGroupId',
      label: 'Tenant Group',
      type: 'select',
      searchable: true,
      options: tenantGroupOptions,
      valueType: 'number',
    },
  ]

  return (
    <CreateEntityPage
      title="Create Inventory System Profile"
      backTo="/inventory-system-profiles"
      loadingLabel="inventory system profile"
      fields={fields}
      createFn={createInventorySystemProfile}
      isLoading={isLoading}
    />
  )
}
